'use client';

import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { cn } from '@workspace/ui/lib';
import { CheckIcon } from 'lucide-react';
import type * as React from 'react';

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      checked={props.value === 'true'}
      className={cn(
        'peer border-grey-700 dark:border-grey-200 h-4 min-h-4 w-4 min-w-4 rounded-[4px] border disabled:cursor-not-allowed data-[state=checked]:border-transparent data-[state=checked]:bg-pink-400 dark:data-[state=checked]:border-transparent dark:data-[state=checked]:bg-pink-400',
        props.disabled
          ? 'border-grey-200 dark:border-grey-800'
          : 'cursor-pointer group-hover:border-pink-400 dark:group-hover:border-pink-400',
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        <CheckIcon className="h-3 max-h-3 w-3 max-w-3 text-neutral-100" strokeWidth={2} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
